import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

export const UnitTag = styled("div")<{ active: "true" | "false" }>(
  ({ theme, active }) => ({
    width: 48,
    height: 32,
    zIndex: 2,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightSemiBold,
    color: active ? theme.palette.common.white : theme.palette.text.primary,
    // background: theme.palette.grey[300],
    cursor: "pointer",
    userSelect: "none",
  })
);

export const ActiveTag = styled("div")(({ theme }) => ({
  width: 48,
  height: 32,
  zIndex: 1,
  position: "absolute",
  textAlign: "center",
  background: theme.palette.text.primary,
  // background: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  cursor: "pointer",
}));

export default function UnitSwitch({ unit, setUnit }): React.ReactElement {
  const handleSwitch = () => {
    setUnit(unit === "CM" ? "IN" : "CM");
  };

  return (
    <Box
      sx={{
        mb: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <Typography variant="subtitle2" sx={{ mr: 2 }}>
        Unit
      </Typography>
      <Box
        sx={{
          display: "flex",
          position: "relative",
          background: (theme) => theme.palette.grey[300],
          borderRadius: 1,
        }}
        onClick={handleSwitch}
      >
        <UnitTag active={unit === "CM" ? "true" : "false"}>CM</UnitTag>
        <UnitTag active={unit === "IN" ? "true" : "false"}>IN</UnitTag>
        <ActiveTag
          sx={
            unit === "CM"
              ? {
                  left: 0,
                }
              : {
                  right: 0,
                }
          }
        />
      </Box>
    </Box>
  );
}
